import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MediaViewerFile, MediaViewerSafeFile } from './media-viewer.models';
import { DomSanitizer } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { getFileName, getSafeUrl } from '@shared/components/media-viewer/media-viewer.helpers';

@Component({
  selector: 'app-media-viewer',
  templateUrl: './media-viewer.component.html',
  styleUrls: ['./media-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaViewerComponent implements OnInit {
  activeIndex: number = 0;
  files: MediaViewerSafeFile[] = [];

  get activeFile(): MediaViewerSafeFile {
    return this.files[this.activeIndex];
  }

  get hasPrev(): boolean {
    return this.activeIndex > 0;
  }

  get hasNext(): boolean {
    return this.activeIndex < this.files.length - 1;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MediaViewerFile[],
    @Inject(DOCUMENT) private document: Document,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.setNormalizedFileData();
  }

  private setNormalizedFileData(): void {
    this.files = this.data.map((file) => ({
      safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(getSafeUrl(file)),
      name: file.name,
    }));
  }

  selectFile(index: number): void {
    this.activeIndex = index;
    this.cd.markForCheck();
  }

  prev(): void {
    if (this.hasPrev) {
      this.activeIndex--;
      this.cd.markForCheck();
    }
  }

  next(): void {
    if (this.hasNext) {
      this.activeIndex++;
      this.cd.markForCheck();
    }
  }

  download(): void {
    const file = this.data[this.activeIndex];
    if (!file) {
      return;
    }

    const link = this.document.createElement('a');
    link.href = getSafeUrl(file);
    link.download = getFileName(file);
    link.click();
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'ArrowLeft') {
      this.prev();
    } else if (event.key === 'ArrowRight') {
      this.next();
    }
  }
}
